import * as React from "react";

import { useNavigate } from "react-router-dom";

export const StatisticByBuildingsHeader: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/statistics");
  };

  return (
    <div className="wrap">
      <div className="intro intro--stats">
        <button type="button" onClick={handleNavigate} className="link link--icon link--arrow-left">
          Back
        </button>
        <h1 className="intro__title">
          Statistics by <span className="intro__title-highlight">buildings</span>
        </h1>
      </div>
    </div>
  );
};
